module.exports = __webpack_public_path__ + "static/img/11.e1a12ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11.jpg
// module id = bRe7
// module chunks = 0